import { render, staticRenderFns } from "./growthAdManager.vue?vue&type=template&id=6a6397a8&scoped=true"
import script from "./growthAdManager.vue?vue&type=script&lang=js"
export * from "./growthAdManager.vue?vue&type=script&lang=js"
import style0 from "./growthAdManager.vue?vue&type=style&index=0&id=6a6397a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6397a8",
  null
  
)

export default component.exports